/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const UPDATECONNECTIONREQUESTSTATUS= createAsyncThunk(
  "updateConnectionRequestStatus/updateConnectionRequestStatus",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateConnectionRequestStatusSlice = createSlice({
  name: "updateConnectionRequestStatusSlice",
  initialState: {
    updateConnectionRequestStatus: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateConnectionRequestStatus: (state) => {
        state.updateConnectionRequestStatus.loading = false
        state.updateConnectionRequestStatus.error = false
        state.updateConnectionRequestStatus.data = []
        state.updateConnectionRequestStatus.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATECONNECTIONREQUESTSTATUS.fulfilled, (state, action) => {
      state.updateConnectionRequestStatus = {
        ...state.updateConnectionRequestStatus,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATECONNECTIONREQUESTSTATUS.pending, (state, action) => {
      state.updateConnectionRequestStatus = {
        ...state.updateConnectionRequestStatus,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATECONNECTIONREQUESTSTATUS.rejected, (state, action) => {
      state.updateConnectionRequestStatus = {
        ...state.updateConnectionRequestStatus,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateConnectionRequestStatusAction = {
    UPDATECONNECTIONREQUESTSTATUS,
};

export { updateConnectionRequestStatusAction };
export default updateConnectionRequestStatusSlice.reducer;
export const {setInitialStateOfupdateConnectionRequestStatus} = updateConnectionRequestStatusSlice.actions